import React, { useState } from 'react';
// import React, { useCallback, useEffect, useState } from 'react';
import { X } from "react-feather";
import { useIntl } from "react-intl";
import { api } from '../../../../api';
import CurrencyInput from "./../../../../components/CurrencyInput";
import "./styles.scss";

const AddBonusModal = ({setError, user, onClose }) => {
  const { formatMessage } = useIntl();
  const [isLoading, setIsLoading] = useState(false);
  const [amountValue, setAmountValue] = useState("");

  function handleSubmit(){
    setIsLoading(true);

    let amountFormated;
    amountFormated = amountValue.replace(/\./g, '');
    amountFormated = amountFormated.replace(/,/g, '.');
    amountFormated = amountFormated.replace(/[^\d.]/g, "");
    
    // console.log("amountFormated", amountFormated);

    api.post(`/b3_transacoes/admin_add_bonus`, {
      pessoa_id: user.pessoa_id,
      valor: amountFormated,
    })
    .then(() => {
      setIsLoading(false);
      onClose();        
    })
    .catch((err) => {
      setError("Erro ao adicionar créditos" || formatMessage({ id: "erro-api" }));
      setIsLoading(false);
      onClose(); 
    });
  }

  return (
    <>
      <div className="modal confirmation-modal is-active">
        <div className="modal-background"></div>
        <div className="modal-card">
          <header className="modal-card-head">
            <div className="modal-card-title">
              Adição de créditos/bônus
            </div>
            <X
              data-testid="close-button"
              className="close-button"
              onClick={onClose}
            />
          </header>

          <section className="modal-card-body">
            <p>Informe o valor do crédito:</p>
            <CurrencyInput
              aria-label="amount-input"
              size="12"
              maxLength="13"
              placeholder="R$ 0,00"
              type="numeric"
              value={amountValue}
              onChange={e => setAmountValue(e.target.value)}
            />

          </section>

          <footer className="modal-card-foot">
            <button className="button" onClick={onClose}>
              {formatMessage({ id: "cancelar" })}
            </button>
            <button
              className={`button primary ${isLoading ? "is-loading" : ""}`}
              onClick={handleSubmit}
            >
              {formatMessage({ id: "continuar" })}
            </button>
          </footer>
        </div>
      </div>
    </>
  );

};

export default AddBonusModal;
